
let formData = {}

// 不需要遍历子字段的
// images -> 主图列表
// verticalImage -> 长图列表
const NO_NEED_CHILDREN_NAMES = ['images', 'verticalImage', 'threeToFourImages']

// 提取尺码分组字段
// function _sizeGroupBySaleProp(saleProp) {
//     let sizeGroup = null
//     function find(children) {
//         children.forEach(c => {
//             if (sizeGroup) return
            
//             if (/-sizeGroup$/.test(c.name)) {
//                 sizeGroup = c
//             }
//             if (c.children && c.children.length) {
//                 find(c.children)
//             }
//         })
//     }
//     find(saleProp.children)
    
//     return sizeGroup
// }

/**
 * 生成 form 表单绑定对象
 * @param {*} formSections 
 */
export const generateFormData = (formSections, parent) => {
    formSections.forEach(item => {
        const fields = item.children, name = item.name

        if (NO_NEED_CHILDREN_NAMES.includes(name)) {
            formData[name] = ''
            return ;
        }

        // if (name === 'saleProp') {
        //     // 销售属性需要特殊处理 
        //     let sizeGroup = _sizeGroupBySaleProp(item)
        //     if (sizeGroup) {
        //         formData[sizeGroup.name] = ''
        //     }
        //     return ;
        // }

        // 类目属性下的多实例复合型控件只要表单只要生成当前这个控件的id就可以了，不需要给子控件生成表单
        // if (parent && parent.name === 'catProp' && item.type === "MULTICOMPLEX") {
        //     formData[name] = [];
        //     return ;
        // }

        if (fields) {
            generateFormData(fields, item)
        } else {
            // 对类目属性下的控件初始值要特殊处理
            // if (parent.name === 'catProp') {
            //     // 输入框类型
            //     if (item.type === "INPUT") {
            //         formData[name] = [{
            //             valueName: '',
            //             pLabel: item.label
            //         }]
            //         return ;
            //     }
            // }

            formData[name] = ''
        }
    })
    // console.log(formData, '-----formdata')
    return formData
}

/**
 * 提供 form 表单绑定数据
 * @param {*} formSections 
 * @returns 
 */
export const getFormData = (formSections) => {
    if (!Array.isArray(formSections) || formSections.length <= 0) return []
    formData = {}
    return generateFormData(formSections)
}